import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  allPosts: null,
  loading: false,
  totalPosts: 0,
  totalPages: 1,
  currentPage: 1,
};

const postReq = createAction("postsRequest");
const postSuccess = createAction("postsSuccess");
const postFail = createAction("postsFailure");

const userPostsReq = createAction("userPostsRequest");
const userPostsSuccess = createAction("userPostsSuccess");
const userPostsFail = createAction("userPostsFailure");

const userPaidVideosReq = createAction("userPaidVideosRequest");
const userPaidVideosSuccess = createAction("userPaidVideosSuccess");
const userPaidVideosFailure = createAction("userPaidVideosFailure");

const userSavedVideosSuccess = createAction("userPaidSavedSuccess");

const recommendationsRequest = createAction("recommendationsRequest");
const recommendationsSuccess = createAction("recommendationsSuccess");
const recommendationsFailure = createAction("recommendationsFailure");

const clear = createAction("clearAllPosts");

export const postReducer = createReducer(initialState, (builder) => {
  builder
    // Posts
    .addCase(postReq, (state, action) => {
      state.loading = true;
    })
    .addCase(postSuccess, (state, action) => {
      state.loading = false;
      state.allPosts = action.payload.posts;
      state.pagination = action.payload.pagination;
      state.totalPosts = action.payload.pagination.totalPosts;
      state.totalPages = action.payload.pagination.totalPages;
      state.currentPage = action.payload.pagination.currentPage;
    })
    .addCase(postFail, (state, action) => {
      state.loading = false;
    })

    // User Posts
    .addCase(userPostsReq, (state, action) => {
      state.loading = true;
    })
    .addCase(userPostsSuccess, (state, action) => {
      state.loading = false;
      state.userPosts = action.payload;
    })
    .addCase(userPostsFail, (state, action) => {
      state.loading = false;
    })

    // Paid Videos
    .addCase(userPaidVideosReq, (state, action) => {
      state.loading = true;
    })
    .addCase(userPaidVideosSuccess, (state, action) => {
      state.loading = false;
      state.userPaidVideos = action.payload;
    })
    .addCase(userPaidVideosFailure, (state, action) => {
      state.loading = false;
    })

    // Recommendations
    .addCase(recommendationsRequest, (state, action) => {
      state.loading = true;
    })
    .addCase(recommendationsSuccess, (state, action) => {
      state.loading = false;
      state.recommendations = action.payload.recommendations;
    })
    .addCase(recommendationsFailure, (state, action) => {
      state.loading = false;
    })
    .addCase(userSavedVideosSuccess, (state, action) => {
      state.userSavedVideos = action.payload;
    })

    .addCase(clear, (state, action) => {
      state.allPosts = null;
      state.userPosts = null;
      state.pagination = null;
      state.totalPosts = 0;
      state.totalPages = 1;
      state.currentPage = 1;
      state.userSavedVideos = [];
    });
});
